<template>
    <div class="avatar" v-bind:style="contents" v-bind:class="{['size-'+size]: size, ['variant-'+variant]: variant}">
        <slot name="tooltip-content"></slot>
        <div class="flex-content text-center" v-bind:style="{'backgroundImage': 'url('+background+')'}">
            <div class="avatar-inner">
                <div class="avatar-inner" >{{short}}
                    <slot v-if="!name&&!background"></slot>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        name: 'Avatar',
        components: {},
        props: {
            contents: {
                type: Object
            },
            size: {
                type: String,
                default: 'md',
                description: 'Could be sm, md, lg, '
            },
            variant: {
                type: String,
                default: 'default'
            },
            name: {
                type: String
            },
            background: {

            }
        },
        data () {
            return {

            }
        },
        computed: {
            short(){
                if(this.name) {
                    let names = this.name.split(" ");
                    let short = names.length === 1
                      ? names[0].substring(0,1)
                      : names[0].substring(0,1) + names[names.length -1].substring(0,1);
                    return short.toUpperCase();
                }
                else{
                    return '';
                }
            }
        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Avatar.scss" scoped lang="scss"></style>

